import React, { useCallback, useState, useEffect } from 'react';
import styled from '@emotion/styled';
import withTranslation from 'hoc/withTranslation';
import NumericInput from '../Global/NumericInput';
import Label from '../../Form/Label';
import Section from '../../Form/Section';

const StyledRow = styled.div({
  display: 'flex',
  gap: '1rem',
  alignItems: 'flex-end',
  paddingTop: '0.5rem',
});

const StyledField = styled.div({
  flex: 1,
});

const StyledHalfField = styled.div({
  width: 'calc(50% - 0.5rem)',
});

const EVChargingInputs = ({
  charging,
  onChargingChange,
  translations: {
    wizard: {
      fleet: { evMinCharge, evMaxCharge, evInitialCharge },
    },
  },
}) => {
  const [localCharging, setLocalCharging] = useState(charging || {});

  useEffect(() => {
    setLocalCharging(charging || {});
  }, [charging]);

  const handleChange = useCallback(
    (field, value) => {
      const updated = { ...localCharging, [field]: value };
      setLocalCharging(updated);
      onChargingChange(updated);
    },
    [localCharging, onChargingChange],
  );

  return (
    <Section>
      <StyledRow>
        <StyledField>
          <Label>{evMinCharge}</Label>
          <NumericInput
            initialValue={localCharging.minCharge ?? ''}
            minValue={0}
            maxValue={100}
            integer
            onChange={(val) => handleChange('minCharge', val)}
          />
        </StyledField>
        <StyledField>
          <Label>{evMaxCharge}</Label>
          <NumericInput
            initialValue={localCharging.maxCharge ?? ''}
            minValue={0}
            maxValue={100}
            integer
            onChange={(val) => handleChange('maxCharge', val)}
          />
        </StyledField>
      </StyledRow>
      <StyledRow>
        <StyledHalfField>
          <Label>{evInitialCharge}</Label>
          <NumericInput
            initialValue={localCharging.initialCharge ?? ''}
            minValue={0}
            maxValue={100}
            integer
            onChange={(val) => handleChange('initialCharge', val)}
          />
        </StyledHalfField>
      </StyledRow>
    </Section>
  );
};

export default withTranslation(EVChargingInputs);
